import {
  ComponentFactoryResolver,
  Directive,
  ElementRef,
  Input,
  OnChanges,
  OnInit,
  Renderer2, SimpleChanges, TemplateRef,
  ViewContainerRef
} from '@angular/core';

@Directive({
    selector: 'button[bwsShowSpinner]',
    standalone: false
})
export class BwsButtonSpinnerDirective implements OnInit, OnChanges {

  @Input('bwsShowSpinner') showSpinner: boolean = false;

  constructor(private el: ElementRef) { }

  ngOnInit() {
  }

  getElement(): HTMLElement {
    return this.el.nativeElement as HTMLElement;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (typeof(changes['showSpinner']) === 'object' && !changes['showSpinner'].isFirstChange()) {
      if (changes['showSpinner'].currentValue === true) {
        this.getElement().classList.add('is-loading');
      }
      if (changes['showSpinner'].currentValue === false) {
        this.getElement().classList.remove('is-loading');
      }
      // this.el.nativeElement.disabled = changes['showSpinner'].currentValue;
    }
  }


}
